$(document).ready(function() {
  $('#modal-apply-job-success-message').modal('show');
});
